import request from '../api';
// 获取App提示词模板分页列表
export function getAppWordTemplatePage(data) {
  return request.post('/app/wordTemplate/getAppWordTemplatePage', data);
}

// 获取App热点事件分页列表
export function getAppHotEventPage(data) {
  return request.post('/app/hotEvent/getAppHotEventPage', data);
}

// 更新用户区域、行业
export function setUserUpdateTrade(data) {
  return request.post('/app/user/updateTrade', data);
}

// chat流式
export function getAiSteamChatChat(data) {
  return request.post('/app/ai/steam-chat/chat', data);
}

// 添加团队提示词模板
export function addWordTemplate(data) {
  return request.post('/app/wordTemplate/addWordTemplate', data);
}
// 添加官方提示词模板
export function addOfficialWordTemplate(data) {
  return request.post('/app/wordTemplate/addOfficialWordTemplate', data);
}

// 修改提示词模板
export function updateWordTemplate(data) {
  return request.post('/app/wordTemplate/updateWordTemplate', data);
}

// 删除提示词模板
export function deleteWordTemplate(id) {
  return request.post(`/app/wordTemplate/deleteWordTemplate/${id}`);
}

// 获取App提示词模板详情
export function getAppWordTemplate(id) {
  return request.post(`/app/wordTemplate/getAppWordTemplate/${id}`);
}
